import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ImageLazyLoad } from '../../';
import './styles.scss';
import Moment from 'react-moment';

const propTypes = {
  user: PropTypes.object,
};

const defaultProps = {
  profileImage: 'https://explore.org/images/icon_avatar_default.png',
}

// @todo: conver to presenttional component
class UserResult extends React.Component {

  render() {
    const { user } = this.props;
    const profileImage = (user.avatar_uri) ? user.avatar_uri : this.props.profileImage;
    let loaderProps = { style: { height:190 }, dark: true }
    return (
      <Link to={"/members/" + user.username}  className="row search-result-item result-info-box no-gutters user-result">
        <div className="col user-image">
          <div className="user-hover-info"><div className="u-font-foundation-light abs-center hover-text">View <br />Member</div></div>
          <img src={profileImage} />
        </div>
        <div className="col">
          <div className="user-text-wrap">
          <h2>{user.username}</h2>
          <hr />
          <div className="row no-gutters u-font-foundation-light">
            <div className="col-6">
              {user.snapshots} <span className="label">Snapshots</span>
            </div>
            <div className="col-6 text-right">
              <span className="label">Member Since</span><br />
              <Moment format="L">{user.joined}</Moment>
            </div>
          </div>
          </div>
        </div>
      </Link>
    )
  }
}

UserResult.propTypes = propTypes;
UserResult.defaultProps = defaultProps;

export default UserResult;
